import { Spacer } from '@vapor/ui';
import { styled } from 'buttered';
import Link from 'next/link';
import React from 'react';
import {
  Award,
  CheckCircle,
  Command,
  Filter,
  Mail,
  MousePointer,
  PenTool,
  Power,
  RefreshCw,
  Users,
  Watch
} from 'react-feather';
import { ActionButton } from '../components/actionButton';
import { Sidebar } from '../components/sidebar';
import { HeaderSubtitle, MainHeader } from '../components/text/mainHeader';
import { MarketingLayout } from '../layout/marketing';

let Header = styled('header')`
  color: black;
  background-color: #ffaaaa;
  background-image: linear-gradient(19deg, #ddddff 20%, #ffcccc 100%);
  padding-top: 60px;

  main {
    max-width: 1000px;
    margin: 0px auto;
    text-align: center;
    padding: 100px 15px 120px 15px;

    @media screen and (max-width: 900px) {
      padding: 30px 15px 40px 15px;
    }
  }
`;

let Main = styled('main')`
  max-width: 1000px;
  margin: 0px auto;

  @media screen and (min-width: 900px) {
    padding-top: 60px;
  }
`;

export let AcademyTitle = styled('h1')`
  font-size: 3em;
`;

export let AcademyMain = styled('main')`
  font-size: 1.3em;
  line-height: 1.3em;

  p {
    margin: 20px 0px;
  }

  h2 {
    margin: 45px 0px 20px 0px;
    font-weight: 600;
    font-size: 1.5em;
  }

  img {
    max-width: 100%;
  }
`;

let Actions = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding-top: 20px;
  margin-bottom: 10vh;

  @media screen and (max-width: 900px) {
    grid-template-columns: 100%;
    margin-bottom: 10px;
  }
`;

export let AcademyLayout = ({
  children,
  active
}: {
  children: React.ReactNode;
  active: string;
}) => {
  let items = [
    {
      id: 'welcome',
      name: 'Welcome',
      href: '/academy',
      icon: <Award />,
      hidden: true
    },
    {
      id: 'team',
      name: 'Teamwork',
      href: '/academy/team',
      icon: <Users />
    },
    {
      id: 'pomodoro',
      name: 'Pomodoro',
      href: '/academy/pomodoro',
      icon: <Watch />
    },
    {
      id: 'command-menu',
      name: 'Command Menu',
      href: '/academy/command-menu',
      icon: <Command />
    },
    {
      id: 'google-calendar',
      name: 'Google Calendar',
      href: '/academy/google-calendar',
      icon: <RefreshCw />
    },
    {
      id: 'digest',
      name: 'Daily Digest',
      href: '/academy/digest',
      icon: <Mail />
    },
    {
      id: 'tags',
      name: 'Tags and Filters',
      href: '/academy/tags',
      icon: <Filter />
    },
    {
      id: 'customize',
      name: 'Customize Weekrise',
      href: '/academy/customize',
      icon: <PenTool />
    },
    {
      id: 'bulk',
      name: 'Bulk Editing',
      href: '/academy/bulk',
      icon: <MousePointer />
    },
    {
      id: 'tips',
      name: 'Tips and Tricks',
      href: '/academy/tips',
      icon: <Power />
    },
    {
      id: 'done',
      name: 'Finish',
      href: '/academy/done',
      icon: <CheckCircle />,
      hidden: true
    }
  ];

  let activeItem = items.find(i => i.id == active);
  let activeIndex = items.indexOf(activeItem);

  let nextItem = items[activeIndex + 1];
  let prevItem = items[activeIndex - 1];

  return (
    <MarketingLayout>
      <Header>
        <main>
          <MainHeader>Weekrise Academy</MainHeader>
          <Spacer height="min(5vh, 20px)" />
          <HeaderSubtitle>Become super productive with Weekrise.</HeaderSubtitle>
        </main>
      </Header>

      <Main>
        <Sidebar active={active} items={items.filter(i => !i.hidden)}>
          {children}

          <Actions>
            <div>
              {prevItem && (
                <Link href={prevItem.href}>
                  <a>
                    <ActionButton
                      name={prevItem.name}
                      icon={prevItem.icon}
                      color="var(--vapor-primary)"
                      description="Previous Article"
                      prev
                    />
                  </a>
                </Link>
              )}
            </div>
            <div>
              {nextItem && (
                <Link href={nextItem.href}>
                  <a>
                    <ActionButton
                      /* @ts-ignore */
                      as="div"
                      name={nextItem.name}
                      icon={nextItem.icon}
                      color="var(--vapor-primary)"
                      description="Next Article"
                    />
                  </a>
                </Link>
              )}
            </div>
          </Actions>
        </Sidebar>
      </Main>
    </MarketingLayout>
  );
};
